var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-title-container"},[_c('svg-icon',{class:`icon type${_vm.type}`,attrs:{"icon-class":_vm.icon}}),_c('span',{class:`type${_vm.type}`},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }